module.exports = {
    create: function(){
        //This is just like any other Phaser create function
    },
    update: function(){
        //Game logic goes here
    },
};